module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_IF_header_03-e325f40bbdcf399266e51653a8d5d95c.jpg";